export default function () {
  return [
    {
      type: 'Input',
      title: '发布组织',
      [$field]: 'publishOrg',
      rules: ['']
    },
    {
      type: 'Input',
      title: '发布人',
      [$field]: 'publisher',
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '发布日期',
      [$field]: 'publishDate',
      rules: ['']
    },
    {
      type: 'textarea',
      title: '组织目标',
      [$field]: 'orgTarget',
      colSpan: 24,
      props: {
        maxlength: 500
      },
      rules: ['']
    },
    {
      type: 'FileUpload',
      title: '附件',
      [$field]: 'file',
      readOnly: true,
      colSpan: 24,
      rules: ['']
    }
  ]
}